import React from 'react';
import { connect } from 'react-redux';
import { Select, Button, AutoComplete, Tag, message, Icon } from 'antd';
import { addFilter, setFilterToAdd, addSecTab, setSecTabToAdd, setPrimaryTabName, setPrimaryTabIcon, getSecTabs, secSecTabSelected, addPrimaryTab, setTemplateName, setReportsToAdd, addTemplate } from '../../../redux/actions/Misc/MiscActions';
import { searchReportTitles } from '../../../redux/actions/Box/BoxActions';
import { getFilterList } from '../../../redux/actions/IC/ICActions';
import AddConfigParametersWrapper from './AddConfigParameters.style';

const Option = Select.Option;
const AutoCompOption = AutoComplete.Option;

class AddConfigParameters extends React.Component {
  
  constructor() {
    super();
    this.handleFilterTextChange = this.handleFilterTextChange.bind(this);
    this.handleAddFilter = this.handleAddFilter.bind(this);
    this.handleSecTabTextChange = this.handleSecTabTextChange.bind(this);
    this.handleAddSecTab = this.handleAddSecTab.bind(this);
    this.handlePrimaryTabNameChange = this.handlePrimaryTabNameChange.bind(this);
    this.handleSetPrimaryTabIcon = this.handleSetPrimaryTabIcon.bind(this);
    this.handleSetPrimaryTabSecTab = this.handleSetPrimaryTabSecTab.bind(this);
    this.handleAddPrimaryTab = this.handleAddPrimaryTab.bind(this);
    this.handleTemplateNameChange = this.handleTemplateNameChange.bind(this);
    this.handleAddReportToList = this.handleAddReportToList.bind(this);
    this.handleAddTemplate = this.handleAddTemplate.bind(this);
    this.handleRemoveReport = this.handleRemoveReport.bind(this);
  }

  componentDidMount() {
    this.props.getSecTabs();
    this.props.getFilterList();
  }

  handleFilterTextChange(e) {
    if(e.target.value === '') {
      document.querySelector('.filter-error-message').classList.remove("show-error-message");
    }
    this.props.setFilterToAdd(e.target.value);
  }
  
  handleAddFilter() {
    if(this.props.MISCREDUCER.filter_to_add === "") {
      document.querySelector('.filter-error-message').classList.add("show-error-message");
    }
    else if(this.props.ICREDUCER.config_1.filters.filter(filter => filter.name === this.props.MISCREDUCER.filter_to_add.toLowerCase()).length > 0) {
      document.querySelector('.filter-error-message').classList.add("show-error-message");
      document.querySelector('.filter-error-message').textContent = 'A filter with this name already exists!';
    }
    else {
      document.querySelector('.filter-error-message').classList.remove("show-error-message");
      this.props.addFilter(this.props.MISCREDUCER.filter_to_add);
    }
  }
  
  
  handleSecTabTextChange(e) {
    if(e.target.value === '') {
      document.querySelector('.sec-tab-error-message').classList.remove("show-error-message");
    }
    this.props.setSecTabToAdd(e.target.value);
  }

  handleAddSecTab() {
    if(this.props.MISCREDUCER.sec_tab_to_add === "") {
      document.querySelector('.sec-tab-error-message').classList.add("show-error-message");
    }
    else if(this.props.MISCREDUCER.primary_tabs.sec_tabs.options.filter(tab => tab.name === this.props.MISCREDUCER.sec_tab_to_add).length > 0) {
      document.querySelector('.sec-tab-error-message').textContent = 'A secondary tab with this name already exists!';
      document.querySelector('.sec-tab-error-message').classList.add("show-error-message");
    }
    else {
      document.querySelector('.sec-tab-error-message').classList.remove("show-error-message");
      this.props.addSecTab(this.props.MISCREDUCER.sec_tab_to_add);
    } 
  }
  

  handlePrimaryTabNameChange(e) {
    this.props.setPrimaryTabName(e.target.value);
  }

  handleSetPrimaryTabIcon(value) {
    this.props.setPrimaryTabIcon(value);
  }

  handleSetPrimaryTabSecTab(value) {
    this.props.secSecTabSelected(value);
  }

  handleAddPrimaryTab() {
    if(this.props.MISCREDUCER.primary_tabs.name.length === 0) {
      document.querySelector('.primary-name-error').classList.add('show-error-message');
    }
    else if (this.props.MISCREDUCER.primary_tabs.icon.selected_icon === undefined || this.props.MISCREDUCER.primary_tabs.icon.selected_icon.length === 0) {
      document.querySelector('.primary-icon-error').classList.add('show-error-message');
    }
    else if (this.props.MISCREDUCER.primary_tabs.sec_tabs.selected.length === 0) {
      document.querySelector('.primary-sec-tab-error').classList.add('show-error-message');
    }
    else {
      document.querySelector('.primary-name-error').classList.remove('show-error-message');
      document.querySelector('.primary-icon-error').classList.remove('show-error-message');
      document.querySelector('.primary-sec-tab-error').classList.remove('show-error-message');
      const data = {
        name: this.props.MISCREDUCER.primary_tabs.name,
        icon: this.props.MISCREDUCER.primary_tabs.icon.selected_icon,
        secondary_tabs: this.props.MISCREDUCER.primary_tabs.sec_tabs.selected
      };
      this.props.addPrimaryTab(data);
    }
  }

  handleTemplateNameChange(e) {
    this.props.setTemplateName(e.target.value);
  }

  handleAddReportToList(value) {
    let reports_to_add = this.props.MISCREDUCER.reports_to_add;
    let new_report_title = this.props.MISCREDUCER.template_report_list.filter(report => report.id === parseInt(value))[0].title;
    let report_obj = {
      id: parseInt(value),
      title:  new_report_title
    };
    let index = reports_to_add.findIndex(function(obj) {
      return obj.id === parseInt(value)
    });
    if(index === -1) {
      reports_to_add.push(report_obj);
      this.props.setReportsToAdd(reports_to_add);
    }
    else {
      message.error('Report already exists in list!');
    }
  }

  handleAddTemplate() {
    let name = this.props.MISCREDUCER.template_to_add;
    let reports = this.props.MISCREDUCER.reports_to_add.map(report => report.id);
    this.props.addTemplate(name,reports);
  }

  handleRemoveReport(i) {
    let reports_to_add = this.props.MISCREDUCER.reports_to_add;
    reports_to_add.splice(i,1);
    this.props.setReportsToAdd(reports_to_add);
  }
  
  render() {

    const icon_options = this.props.MISCREDUCER.primary_tabs.icon.icon_list.map((icon,i) => <Option key={i} value={icon.value}>{icon.text}</Option>);
    const sec_tab_options = this.props.MISCREDUCER.primary_tabs.sec_tabs.options.map((tab,i) => <Option key={i} value={tab.name}>{tab.name}</Option>);
    const report_titles = this.props.MISCREDUCER.template_report_list.length && this.props.MISCREDUCER.template_report_list.map(report => <AutoCompOption value={report.id.toString()}>{report.title}</AutoCompOption>);
    let report_title_tags = this.props.MISCREDUCER.reports_to_add.length ? this.props.MISCREDUCER.reports_to_add.map((report,i) => <p className="ant-tag report-title">{report.title}<Icon type="close" onClick={() => this.handleRemoveReport(i)} /></p>) : '';

    return(
      <AddConfigParametersWrapper>
      
      <div className="add-primary-tabs">
        <p className="input-label" style={{marginLeft: 20}}>Add a Primary Tab: </p>
        <div className="flex">
          <div className="custom-form-group">
            <input className="ant-input" value={this.props.MISCREDUCER.primary_tabs.name} placeholder="Primary Tab Name" onChange={(e) => this.handlePrimaryTabNameChange(e)} />
            <p className="error-message primary-name-error">Enter a Valid Primary Tab Name!</p>
          </div>
          <div className="custom-form-group">
            <Select style={{ width: '100%' }} value={this.props.MISCREDUCER.primary_tabs.icon.selected_icon} onChange={this.handleSetPrimaryTabIcon} placeholder="Select Primary Tab Icon" >
              {icon_options}
            </Select>
            <p className="error-message primary-icon-error">Select a Primary Tab Icon!</p>
          </div>
          <div className="custom-form-group">
            <Select mode="multiple" style={{ width: '100%' }} value={this.props.MISCREDUCER.primary_tabs.sec_tabs.selected} onChange={this.handleSetPrimaryTabSecTab} placeholder="Select Secondary Tabs for Primary Tab" >
              {sec_tab_options}
            </Select>
            <p className="error-message primary-sec-tab-error">Select a set of Secondary Tabs!</p>
          </div>
          <Button type="primary" style={{ margin: '10px 20px' }} loading={this.props.MISCREDUCER.addingPrimaryTab} onClick={this.handleAddPrimaryTab}>Add</Button>
        </div>
      </div>
      
      <div className="flex parameters-wrapper">
        <div className="add-parameter">
          <p className="input-label">Add a Filter: </p>
          <div className="flex">
            <input className="ant-input" value={this.props.MISCREDUCER.filter_to_add} placeholder="Filter Name" onChange={(e) => this.handleFilterTextChange(e)} />
            <Button type="primary" className="add-parameter-btn" loading={this.props.MISCREDUCER.addingFilter} onClick={this.handleAddFilter}>Add</Button>
          </div>
          <p className="error-message filter-error-message">Enter a valid filter name!</p>
        </div>
        <div className="add-parameter">
          <p className="input-label">Add a Secondary Tab: </p>
          <div className="flex">
            <input className="ant-input" value={this.props.MISCREDUCER.sec_tab_to_add} placeholder="Secondary Tab Name" onChange={(e) => this.handleSecTabTextChange(e)} />
            <Button type="primary" className="add-parameter-btn" loading={this.props.MISCREDUCER.addingSecTab} onClick={this.handleAddSecTab}>Add</Button>
          </div>
          <p className="error-message sec-tab-error-message">Enter a valid secondary tab name!</p>
        </div>
      </div>

      <div className="flex add-report-template">
        <div className="form-input-group">
          <p className="input-label">Template Name: </p>
          <input className="ant-input" type="text" placeholder="Enter template name" value={this.props.MISCREDUCER.template_to_add} onChange={(e) => this.handleTemplateNameChange(e)} />
          <p className="error-message">Enter a valid template name</p>
        </div>
        <div className="form-select-group">
          <p className="select-label">Search and select Report List: </p>
          <AutoComplete
            allowClear
            style={{ width: '100%' }}
            onSearch={(value) => this.props.searchReportTitles(value,'misc')}
            onSelect={this.handleAddReportToList}
            placeholder="Search report here"
          >
            {report_titles}
          </AutoComplete>
          <p className="error-message">Select a valid list of reports!</p>
          <div className="flex selected-reports-list">
            {report_title_tags}
          </div>
        </div>
        <Button className="add-template-btn" loading={this.props.MISCREDUCER.addingTemplate} type="primary" onClick={this.handleAddTemplate}>Add</Button>
      </div>
      </AddConfigParametersWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  addFilter,
  setFilterToAdd,
  addSecTab,
  setSecTabToAdd,
  setPrimaryTabName,
  setPrimaryTabIcon,
  getSecTabs,
  secSecTabSelected,
  addPrimaryTab,
  getFilterList,
  setTemplateName,
  searchReportTitles,
  setReportsToAdd,
  addTemplate
};

export default connect(mapStateToProps, mapDispatchToProps)(AddConfigParameters);


// WEBPACK FOOTER //
// ./src/components/Miscellaneous/AddConfigParemeters/AddConfigParameters.js